// Advice routes
const adviceRouter = [
    {
        path: "/advice-topics",
        name: "AdviceTopics",
        component: () => import("@/Views/AdviceTopics/AdviceMain.vue"),
        children: [
            {
                path: "career-advice",
                name: "CareerAdvice",
                component: () => import("@/Views/AdviceTopics/CareerAdvice.vue")
            },
            {
                path: "education-advice",
                name: "EducationAdvice",
                component: () => import("@/Views/AdviceTopics/EducationAdvice.vue")
            },
            {
                path: "life-advice",
                name: "LifeAdvice",
                component: () => import("@/Views/AdviceTopics/LifeAdvice.vue")
            },
            {
                path: "personal-development",
                name: "PersonalDevelopment",
                component: () => import("@/Views/AdviceTopics/PersonalDevelopment.vue")
            },
            {
                path: "relationship-advice",
                name: "RelationshipAdvice",
                component: () => import("@/Views/AdviceTopics/RelationAdvice.vue")
            },
            {
                path: "tech-advice",
                name: "TechAdvice",
                component: () => import("@/Views/AdviceTopics/TechAdvice.vue")
            },
            {
                path: "metal-support",
                name: "MentalSupport",
                component: () => import("@/Views/AdviceTopics/MentalSupport.vue")
            }

        ]
    }
];

export default adviceRouter;